import { IsNotEmpty, IsIn } from "class-validator";
import { Constants } from "@eagerdog/constants";

import { IProperty } from "../common";

export class DogVariationDto implements IProperty {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.sanctioning_club))
  name: string;

  @IsNotEmpty()
  value: string;
}
